"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    productVersion: '5.6.11',
    version: '5.6.11',
    ciBuildtimestamp: '2c7c25ad9ddf9189b35277b007e43dff3b3f4b54',
    commit: '2c7c25a',
    ciBuildNumber: '10272',
};
//# sourceMappingURL=info.js.map